import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowRightFromBracket,
    faBoxArchive,
    faDatabase,
    faDownLeftAndUpRightToCenter,
    faMicrochip,
    faSliders,
    faTruckRampBox
} from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import ButtonWrap from '../../components/template/ButtonWrap';
import { useEffect, useState } from 'react';

const MainPage = () => {
    const [expDate, setExpDate] = useState()
    const navigate = useNavigate()

    useEffect(() => {
        try {
            setExpDate(localStorage.getItem('expiredAt'))
        } catch {
            navigate('/signin')
        }
    }, [navigate])
    return (
        <div className='default-background flex flex-col'>
            <div className="text-right">
                <p className='text-gray-400 p-1'>Login expires at: {expDate}</p>
                <ButtonWrap contents={<p><FontAwesomeIcon icon={faArrowRightFromBracket} /> Log out</p>} onClick={() => navigate('/signin')} />
            </div>
            <div className='flex flex-col flex-1'>
                <div className='self-center pb-12 my-auto'>
                    <img src='eats_logo.png' alt='logo' className='m-auto' />
                </div>
                <div className='md:grid md:grid-cols-3 md:auto-rows-fr md:gap-6 w-full mx-auto my-4 px-8'>
                    {[
                        { title: 'Cochl DBs', icon: faDatabase, to: '/db-generation', description: 'Generate training dataset snapshots and check their build status' },
                        { title: 'Experiments & Training', icon: faMicrochip, to: '/experiments', description: 'Set up experiments and train models with the settings you want' },
                        { title: 'Models', icon: faTruckRampBox, to: '/model-selection', description: 'Evaluate, convert, deploy, and download trained models' },
                        { title: 'Evaluation Comparison', icon: faDownLeftAndUpRightToCenter, to: '/evaluation-comparison', description: 'Compare evaluation results side by side on any testset, including benchmarks' },
                        { title: 'Service Archive', icon: faBoxArchive, to: '/service-archive', description: 'Browse deployed services by service group' },
                        { title: 'Custom Sound', icon: faSliders, to: '/custom-sound', description: 'Track Custom Sound requests' },
                    ].map((e, i) => <Link to={e.to} key={i} className='block my-4 md:my-0 h-full'>
                        <div className='h-full min-h-[8rem] rounded-lg border px-6 py-5 text-left select-none transition duration-150 hover:border-cyan-600 hover:bg-cyan-50/50 hover:shadow-md'>
                            <div className='flex items-center gap-3'>
                                <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-cyan-50 text-cyan-700'>
                                    <FontAwesomeIcon icon={e.icon} />
                                </div>
                                <div className='text-lg font-semibold'>{e.title}</div>
                            </div>
                            <div className='mt-2 text-sm text-gray-500'>{e.description}</div>
                        </div>
                    </Link>)}
                </div>
            </div>
        </div>
    )
}

export default MainPage